var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"button clickable",class:{'is-outlined': !_vm.selected},style:(_vm.style),on:{"mouseenter":_vm.setSelectedStyle,"mouseleave":_vm.setNormalStyle,"click":_vm.toggleClick}},[_vm._v(_vm._s(_vm.category.name))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-09301ddb","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/premade-comments/components/CategoryItem.vue
// module id = WK54
// module chunks = 0